import React from 'react'
import './Experience.css'

const Experience = () => {
  return (
    <div className="experience" id='Experience'>
        <div className="achievement">
            <div className="circle" >4+</div>
            <span>years</span>
            <span>Experience</span>
        </div>

        <div className="achievement">
            <div className="circle">40+</div>
            <span>Completed</span>
            <span>Projects</span>
        </div>

        <div className="achievement">
            <div className="circle">6+</div>
            <span>Businesses</span>
            <span>Worked With</span>
        </div>
    </div>
    

  )
}

export default Experience